import { makeStyles } from '@material-ui/core/styles'

export const useStylesUpload = makeStyles(() => ({
  uploadWrap: {
    maxWidth: 600,
  },
  uploadInputWrap: {
    padding: 15,
    border: '1px dashed',
    textAlign: 'center'
  },
  uploadNote: {
    fontSize: '75%'
  },

  file__content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 10px !important',
  },
  file__name_wrapper: {
    width: '55%',
    display: 'flex',
    alignItems: 'center',
  },
  file__name_wrapper__name: {
    marginLeft: 5,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontWeight: 'bold'
  },
  file__btn: {
    width: 55
  }
}))
